import axios from 'axios';
import FetchRequestList from './FetchRequestList';

import store from '../store';
import storage, { keys } from './storage';
import { appActions } from '../store/modules/app';
import { COMMON_RES_CODE } from '../constants/responseCode/commonResCode';
import { asyncSimpleModal } from './common';

const getBaseUrl = () => {
  if (import.meta.env?.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }
  return 'https://www.testApiV1.com';
};

const SuperFetch = axios.create({
  baseURL: getBaseUrl() + '/api',
});

const customHeader = () => {
  const user = storage.get(keys.user);
  return {
    accept: 'application/json',
    authorization: user ? 'Bearer ' + user : undefined,
  };
};

export class V1ApiError extends Error {
  constructor(message, status) {
    super(message);
    this.name = 'V1 ApiError';
    this.status = status;
  }
}

/**
 *  서버에 request 를 보내기 전에
 *  전체 스피너 작동여부를 판담함
 */
SuperFetch.interceptors.request.use((req) => {
  req.headers = customHeader();
  const fetchRequestList = FetchRequestList.getInstance();

  const data = req.data;
  let isSpinner = null;

  if (data && Object.prototype.hasOwnProperty.call(data, 'isSpinner')) {
    /**
     *  스피너 토글
     */
    isSpinner = req.data.isSpinner;

    /**
     *  서버로 보내질 데이터에서 isSpinner 속성을 지우기
     */
    delete req.data.isSpinner;
  } else if (data instanceof FormData && data.get('isSpinner') === 'true') {
    /**
     *  스피너 토글
     */
    isSpinner = data.get('isSpinner') === 'true';

    /**
     *  서버로 보내질 데이터에서 isSpinner 속성을 지우기
     */
    req.data.delete('isSpinner');
  }

  isSpinner && store.dispatch({ type: appActions.SET_FULLSCREEN_LOADER, payload: true });

  fetchRequestList.add(req.url);

  return req;
});

/**
 *  서버에서 response 을 받으면,
 *  전체 스피너를 종료함
 *  서버의 응답 코드에 따른 분기처리함
 */
SuperFetch.interceptors.response.use(
  async (res) => {
    const fetchRequestList = FetchRequestList.getInstance();
    fetchRequestList.complete(res.config.url.replace(res.config.baseURL, ''));
    /**
     *  모든 요청이 응답 완료 시 전체 스피너 종료
     */
    if (fetchRequestList.isAllComplete) {
      store.dispatch({ type: appActions.SET_FULLSCREEN_LOADER, payload: false });
    }
    if (
      res.data.status === COMMON_RES_CODE.INACTIVE_USER ||
      res.data.status === COMMON_RES_CODE.INACTIVE_USER_INVALID_REQUEST ||
      res.data.status === COMMON_RES_CODE.INVALID_TOKEN ||
      res.data.status === COMMON_RES_CODE.EXPIRATION_TOKEN
    ) {
      // 하단의 라인은 아직 에러처리를  시행하지 않는곳에서 처리하기 위해 남겨둡니다.
      // todo: 에러 핸들링을 네트워크 레이어에서 분리하기
      const proceed = await asyncSimpleModal({
        type: 'error',
        title: '만료된 토큰',
        message: '만료된 토큰입니다. 로그아웃으로 전환됩니다.',
      });
      if (proceed) {
        storage.remove(keys.user);
        window.location.reload();
      }
      // api를 실행하는 곳에서 try catch 문을 통해 에러를 핸들링할 수 있도록 전달
      // 쿼리 훅을 사용하는 곳에서는 onError에서 해당 에러가 처리됩니다.
      throw new V1ApiError(res.data.msg, res.data.status);
    } else if (res.data.status === COMMON_RES_CODE.INVALID_PASSWORD) {
      throw new V1ApiError(res.data.msg, res.data.status);
    } else if (res.data.status === COMMON_RES_CODE.UNAUTHENTICATED_USER_REQUEST) {
      throw new V1ApiError(res.data.msg, res.data.status);
    }
    return res.data;
  },
  (error) => {
    /**
     *  스피너 토글
     */
    store.dispatch({ type: appActions.SET_FULLSCREEN_LOADER, payload: false });
    return Promise.reject(error);
  },
);

SuperFetch.defaults.timeout = 120000;

export default SuperFetch;
